module.exports = __webpack_public_path__ + "static/media/image_4.83425623.png";